// extracted by mini-css-extract-plugin
module.exports = {"user-menu":"user-menu-3_FGT","menu":"menu-2Fxt4","account":"account-3vSeR","user-name":"user-name-k6wEH","avatar":"avatar-2i4F0"};